/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_A4Inputs */

const en_fw_faq_a4 = /** @type {(inputs: Fw_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`david production, directed by Takahiro Kamei, with series composition by Yūko Kakihara, character design by Yukiko Aikei and music by Nogrid.`)
};

const zh_fw_faq_a4 = /** @type {(inputs: Fw_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`david production 制作，监督亀井隆広，系列构成柿原優子，角色设计愛敬由紀子，音乐 Nogrid。`)
};

/**
* | output |
* | --- |
* | "david production, directed by Takahiro Kamei, with series composition by Yūko Kakihara, character design by Yukiko Aikei and music by Nogrid." |
*
* @param {Fw_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_a4 = /** @type {((inputs?: Fw_Faq_A4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_A4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_a4(inputs)
	return zh_fw_faq_a4(inputs)
});
export { fw_faq_a4 as "fw.faq.a4" }